import {
	IconHome,
	IconEdit,
	IconGridRectangle,
	IconApps,
	IconTickCircle,
	IconAlertTriangle,
	IconUser,
	IconLanguage,
	IconFile,
	IconUserAdd
} from '@douyinfe/semi-icons'

export const ADMIN_MENU_CONFIG  = [
	{
		itemKey: '1',
		text: 'app.menu.dashboard',
		icon: IconHome,
		items: [
			{
				itemKey: '1-1',
				text: 'app.menu.dashboard.learn',
				path: '/dashboard/learn'
			},
			// {
			// 	itemKey: '1-2',
			// 	text: 'app.menu.dashboard.preach',
			// 	path: '/dashboard/preach'
			// },
		]
	},
	{
		itemKey: '2',
		text: 'app.menu.learn',
		icon: IconEdit,
		items: [
			{
				itemKey: '2-1',
				text: 'app.menu.learn.plan',
				path: '/learn/plan'
			},
			{
				itemKey: '2-2',
				text: 'app.menu.learn.manager',
				path: '/learn/manager',
			},
			{
				itemKey: '2-3',
				text: 'app.menu.learn.check',
				path: '/learn/check'
			},
			{
				itemKey: '2-4',
				text: 'app.menu.learn.state',
				path: '/learn/state'
			}
		]
	},
	{
		itemKey: '3',
		text: 'app.menu.preach',
		icon: IconLanguage,
		items: [
			{
				itemKey: '3-1',
				text: 'app.menu.preach.team',
				path: '/preach/team'
			},
			{
				itemKey: '3-2',
				text: 'app.menu.preach.plan',
				path: '/preach/plan'
			},
			{
				itemKey: '3-3',
				text: 'app.menu.preach.task_check',
				path: '/preach/task_check'
			},
		]
	},
	{
		itemKey: '4',
		text: 'app.menu.material',
		icon: IconFile,
		items: [
			{
				itemKey: '4-1',
				text: 'app.menu.material.manager',
				path: '/material/manager'
			},
		]
	},
	{
		itemKey: '5',
		text: 'app.menu.account',
		icon: IconUserAdd,
		items: [
			{
				itemKey: '5-1',
				text: 'app.menu.account.manager',
				path: '/account/manager'
			},
			{
				itemKey: '5-2',
				text: 'app.menu.account.config',
				path: '/account/config'
			}
		]
	},
]




export const USER_MENU_CONFIG  = [
	{
		itemKey: '1',
		text: 'app.menu.unit.dashboard',
		icon: IconHome,
		items: [
			{
				itemKey: '1-1',
				text: 'app.menu.unit.dashboard.learn',
				path: '/unit/dashboard/learn'
			},
			// {
			// 	itemKey: '1-2',
			// 	text: 'app.menu.unit.dashboard.preach',
			// 	path: '/unit/dashboard/preach'
			// },
		]
	},
	{
		itemKey: '2',
		text: 'app.menu.unit.learn',
		icon: IconEdit,
		items: [
			{
				itemKey: '2-1',
				text: 'app.menu.unit.learn.plan',
				path: '/unit/learn/plan'
			},
			{
				itemKey: '2-2',
				text: 'app.menu.unit.learn.task.report',
				path: '/unit/learn/task_report',
			},
			{
				itemKey: '2-3',
				text: 'app.menu.unit.learn.report',
				path: '/unit/learn/report'
			}
		]
	},
	{
		itemKey: '3',
		text: 'app.menu.unit.preach',
		icon: IconLanguage,
		items: [
			{
				itemKey: '3-1',
				text: 'app.menu.unit.preach.team',
				path: '/unit/preach/team/build'
			},
			{
				itemKey: '3-2',
				text: 'app.menu.unit.preach.task',
				path: '/unit/preach/task'
			},
			{
				itemKey: '3-3',
				text: 'app.menu.unit.preach.report',
				path: '/unit/preach/report'
			},
			{
				itemKey: '3-4',
				text: 'app.menu.preach.plan',
				path: '/unit/preach/plan'
			},
		]
	},
	{
		itemKey: '4',
		text: 'app.menu.unit.material',
		icon: IconFile,
		items: [
			{
				itemKey: '4-1',
				text: 'app.menu.unit.material.manager',
				path: '/unit/material/manager'
			},
		]
	},
]